/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M7.5 4.5c0-1.6568-1.3431-3-3-3-1.6568 0-3 1.3432-3 3 0 .7068.2444 1.3565.6534 1.8692C2.703 7.0584 3.5499 7.5 4.5 7.5c1.6569 0 3-1.3431 3-3ZM5.25 8.9378C7.3783 8.5808 9 6.7298 9 4.5 9 2.0147 6.9853 0 4.5 0S0 2.0147 0 4.5c0 2.1746 1.5425 3.989 3.593 4.4086.052.0106.1044.0204.157.0292v6.1244C1.6217 15.4193 0 17.2703 0 19.5 0 21.9853 2.0147 24 4.5 24S9 21.9853 9 19.5c0-1.8413-1.106-3.4244-2.6898-4.1211a4.466 4.466 0 0 0-.9589-.2985 2.2561 2.2561 0 0 1 1.0257-1.2805A2.239 2.239 0 0 1 7.5 13.5h9c2.0711 0 3.75-1.6789 3.75-3.75v-.8122C22.3783 8.5808 24 6.7298 24 4.5 24 2.0147 21.9853 0 19.5 0S15 2.0147 15 4.5c0 2.1746 1.5425 3.989 3.5931 4.4086.052.0106.1043.0204.1569.0292V9.75c0 1.2426-1.0074 2.25-2.25 2.25h-9a3.7645 3.7645 0 0 0-.75.075 3.7252 3.7252 0 0 0-1.0976.411 3.7627 3.7627 0 0 0-.4024.2637v-3.812ZM1.5 19.5c0 1.6569 1.3432 3 3 3 1.6569 0 3-1.3431 3-3s-1.3431-3-3-3c-1.6568 0-3 1.3431-3 3Zm21-15c0-1.6568-1.3431-3-3-3s-3 1.3432-3 3a2.987 2.987 0 0 0 .6534 1.8692C17.7031 7.0584 18.55 7.5 19.5 7.5c1.6569 0 3-1.3431 3-3Z"
    clipRule="evenodd"
  />,
  'Branch'
);
